import { mount } from "@eusoft/webapp-core/TemplateBuilder";
import { App, localTable, router } from "@eusoft/webapp-framework";
import env from "environment"
import { setPaymentService } from "./abstraction/IPaymentService";
import { AppContentHost } from "./components/AppContentHost";
import { SwipeRefresh } from "./components/SwipeRefresh";
import { BusinessNavigation, processNavAsync } from "./entities/Navigation";
import { PAGES } from "./entities/Pages";
import { config } from "./services/Configuration";
import { context } from "./services/Context";
import { MockPayment } from "./services/MockPayment";
import { isNativeApp, nativeApp } from "./services/NativePayment";
import { apiClient } from "./services/PmApiClient";
import { loadTheme } from "./services/Theme";
import { analytics } from "./services/Analytics";

export class PmApp extends App<AppContentHost> {

    override createContentHost() {

        return new AppContentHost();
    }

    protected override async onStarted() {

        window.onunhandledrejection = function (event) {
            console.error("Unhandled Promise rejection:", event.reason);
            // event.preventDefault();
        };

        loadTheme();
        
        if (isNativeApp())
            document.body.classList.add("native");

        await config.loadAsync();

        if (config.current?.gaTag)
            analytics.init(config.current.gaTag);

        apiClient.endpoint = config.current.apiUrl;

        localTable.language = "IT";

        for (const page of PAGES)
            router.addPage(page);

        await processNavAsync(...BusinessNavigation);

        if (navigator.serviceWorker && env == "prod") {
            await navigator.serviceWorker.register("/sw.js", {

            })
        }

        if (isNativeApp())
            setPaymentService(nativeApp);
        else
            setPaymentService(new MockPayment());

        await context.updateOptionsAsync();

        router.startAsync();

        if (env == "dev")
            this.liveReload();

        mount(document.body, this.swipeRefresh);
    }

    readonly swipeRefresh = new SwipeRefresh();
}

